<script>
	import Ribbon from '../../../components/v0/Lobby/Ribbon.svelte';
	import Vector from '../../../assets/vector.svelte';
	export let countDown = 5;
	export let ribbonText = '';
	export let displayCounter = false;
</script>

<div class="timerContainer">
	{#if displayCounter === true}
		<div class="numberContainer">
			<div class="vectorTop"><Vector /></div>
			<div class="vectorBottom"><Vector /></div>
			<div class="numberValue">
				<!-- //add | "" here -->
				{countDown}
			</div>
			{#if ribbonText && ribbonText.length > 0}
				<div class="modeWrapper">
					<Ribbon width="200" height="47" text={`${ribbonText}`} fontSize="23" />
				</div>
			{/if}
		</div>
	{/if}
</div>

<style>
	.timerContainer {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 100%;
		padding: 2%;
	}
	.numberContainer {
		margin: 9vh;
		width: 250px;
		height: 250px;
		background: #ffffff;
		box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.25), inset 0px -10px 0px #d1d1d1;
		border-radius: 50%;
		position: relative;
	}

	.numberValue {
		font-family: Manrope;
		font-style: normal;
		font-weight: 800;
		font-size: 160px;
		line-height: 140.1%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: var(--base-d-60);
	}

	.modeWrapper {
		position: absolute;
		bottom: 5px;
		left: 50%;
		transform: translate(-50%);
	}

	.vectorTop,
	.vectorBottom {
		position: absolute;
		height: 318px;
		width: 615px;
		left: 50%;
		z-index: 0;
	}

	.vectorTop {
		top: -125px;
		transform: translate(-50%);
	}
	.vectorBottom {
		transform: rotate(180deg) translate(50%);
	}
	.vectorBottom {
		bottom: -125px;
	}
</style>
